import React, { useContext, useState, useRef, useEffect } from "react";
import { AuthContext } from "../context/AuthContext";

import { checkUsername } from "../Utils/Validation";
import { db, serverTime } from "../Utils/firebase";

function EditUsername() {
  const { userData, userAuth, setUserData } = useContext(AuthContext);
  const [disable, setDisable] = useState(true);
  const [username, setUsername] = useState(userData.username);
  const [char, setChar] = useState(userData.username.length);
  const [btnText, setBtnText] = useState("Save");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [mount, setMount] = useState(true);
  const userRef = useRef();

  const handleChange = (e) => {
    if (
      e.target.value.length > e.target.maxLength &&
      e.keyCode !== 46 &&
      e.keyCode !== 8
    ) {
      e.preventDefault();
    } else {
      setUsername(e.target.value);
    }
  };

  const handleChar = (e) => {
    if (
      e.target.value.length > e.target.maxLength &&
      e.keyCode !== 46 &&
      e.keyCode !== 8
    ) {
      e.preventDefault();
    } else if (e.keyCode === 190 || e.keyCode === 110) {
      e.preventDefault();
    } else {
      setChar(e.target.value.length);
      setDisable(false);
      setBtnText("Save");
    }
  };

  const handleBlur = () => {
    if (username === userData.username) {
      setDisable(true);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const isSame = username === userData.username;
    const isNotNull = username !== "";
    const checkName = checkUsername(username);

    if (!isSame && isNotNull) {
      if (checkName === true) {
        setLoading(true);
        setDisable(true);
        setBtnText("Checking ... ");
        setError("Only Letter and Number Allowed with No Space");

        const un = username.trim().toLowerCase().toString();
        const nsun = un.replace(/\s+/g, "");

        db.collection("user")
          .where("username", "==", nsun)
          .get()
          .then((docs) => {
            if (docs.empty) {
              if (mount) {
                setBtnText("Saving ... ");
              }
              db.collection("user")
                .doc(userAuth.uid)
                .update({
                  username: nsun,
                  updateAt: serverTime,
                })
                .then(() => {
                  db.collection("user")
                    .doc(userAuth.uid)
                    .get()
                    .then((doc) => {
                      setUserData(doc.data());
                      if (mount) {
                        setUsername(doc.data().username);
                        setBtnText("Saved");
                        setLoading(false);
                      }
                    })
                    .catch((error) => {
                      if (mount) {
                        setBtnText("Save");
                        setError(error.message);
                        setLoading(false);
                      }
                    });
                })
                .catch((error) => {
                  if (mount) {
                    setBtnText("Save");
                    setError(error.message);
                    setLoading(false);
                  }
                });
            } else {
              if (mount) {
                setBtnText("Save");
                setError("Username Not Available");
                setLoading(false);
              }
            }
          })
          .catch((error) => {
            if (mount) {
              setBtnText("Save");
              setError(error.message);
              setLoading(false);
            }
          });
      } else {
        if (mount) {
          userRef.current.focus();
          setError(
            "Username Not valid, use Lowercase Letter First and Minimum 4 Char"
          );
          setLoading(false);
        }
      }
    } else {
      if (mount) {
        userRef.current.focus();
        setError(
          "Username Not valid, use Lowercase Letter First and Minimum 4 Char"
        );
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    return () => {
      setMount(false);
    };
  }, []);

  return (
    <div className="edit-username divContent darktextColor darkdivColor">
      <div className="head-tab">
        <h5 className="textTitle textMedium">Username</h5>
        <p className="text">{char} / 32</p>
      </div>
      <form className="user-form" onBlur={handleBlur} onSubmit={handleSubmit}>
        <div className="grup-input">
          <label>
            <input
              type="text"
              className="input-1"
              name="username"
              id="username"
              placeholder="Enter your username"
              value={username}
              onChange={handleChange}
              onKeyUp={handleChar}
              maxLength="32"
              ref={userRef}
              disabled={loading}
            />
          </label>
        </div>

        <button
          className={
            disable
              ? "btn-in darktextColor textTitle disable"
              : "btn-in darktextColor textTitle "
          }
          disabled={disable}
          type="submit"
        >
          {btnText}
        </button>
      </form>
      {error ? (
        <p className="textSmall">{error}</p>
      ) : (
        <p className="textSmall">
          Only Letter and Number Allowed with No Space
        </p>
      )}
    </div>
  );
}

export default EditUsername;
